/**
 * Template toolchain-contracts.yaml derived from probe (package.json scripts).
 */

import type { ProbeResult } from "./probe.js";

export function generateToolchainContractsYaml(probe: ProbeResult): string {
  const systemId = probe.packageJson?.name?.replace(/[^a-z0-9-]/gi, "-").toLowerCase() ?? "project";
  const systemName = probe.packageJson?.name ?? "Project Toolchains";
  const scripts = probe.packageJson?.scripts ?? {};
  const toolchains: string[] = [];

  if (scripts.lint) {
    toolchains.push(`  linter:
    kind: cli
    description: Lint source code
    command: npm run lint
    artifacts:
      consumes: [codebase]
      produces: [codebase]
    operations: [lint]`);
  }

  if (scripts.test) {
    const testCmd = probe.isMonorepo
      ? "npm test --workspaces --if-present"
      : "npm test";
    toolchains.push(`  test-runner:
    kind: cli
    description: Run project test suite
    command: ${testCmd}
    artifacts:
      consumes: [codebase, test-code]
      produces: []
    operations: [test]`);
  }

  if (scripts.build) {
    toolchains.push(`  build:
    kind: cli
    description: Build project artifacts
    command: npm run build
    artifacts:
      consumes: [codebase]
      produces: [codebase]
    operations: [build]`);
  }

  if (probe.existingConfigs.componentContracts.length > 0) {
    for (const contract of probe.existingConfigs.componentContracts) {
      const id = contract.replace(/\.(yaml|yml)$/, "").replace(/-contract$/, "");
      toolchains.push(`  ${id}-validator:
    kind: cli
    description: Validate ${contract}
    command: npx aaac validate ${contract}
    artifacts:
      consumes: [agent-dsl]
      produces: []
    operations: [validate]`);
    }
  }

  const body = toolchains.length > 0 ? toolchains.join("\n\n") : `  # No npm scripts detected — add toolchains manually`;

  return `schema: aaac/toolchain/0.1

system:
  id: ${systemId}
  name: ${systemName}

toolchains:
${body}
`;
}
